module.exports = __webpack_public_path__ + "img/senalando2_btn.5edcce3d.png";